import { NgModule } from '@angular/core';
import { CmsConfig, provideDefaultConfigFactory } from '@spartacus/core';
import { ATG_PRODUCT_FEATURE_SPECS_FEATURE } from './feature-name';

export function atgProductFeatureSpecsComponentsConfig(): CmsConfig {
  return {
    featureModules: {
      [ATG_PRODUCT_FEATURE_SPECS_FEATURE]: {
        cmsComponents: ['KnBrProductFeaturesSpecsComponent'],
      },
    },
  };
}

@NgModule({
  providers: [provideDefaultConfigFactory(atgProductFeatureSpecsComponentsConfig)],
})
export class AtgProductFeatureSpecsRootModule {}
